import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Privacidad = () => {
    return (
        <section className='bg-primary text-white'>
            <Container className='py-5'>
                <Row className='justify-content-center'>
                    <Col lg={8} md={8} sm={12} xs={12} className='py-5'>
                    <h1>Política de Privacidad</h1>
                    <h2>Recopilación de Información Personal</h2>
                    <p>Recopilamos información personal, como nombre y correo electrónico, que usted proporciona voluntariamente al completar el formulario de contacto.</p>

                    <h2>Uso de la Información</h2>
                    <p>La información recopilada se utilizará exclusivamente para responder a sus consultas y no será utilizada con fines publicitarios ni promocionales sin su consentimiento previo.</p>

                    <h2>Confidencialidad y Divulgación</h2>
                    <p>Garantizamos la confidencialidad de su información. No la compartiremos con terceros en ninguna circunstancia, salvo en cumplimiento de obligaciones legales.</p>

                    <h2>Almacenamiento y Eliminación</h2>
                    <p>Los datos proporcionados serán almacenados de forma segura durante un periodo máximo de 30 días, tras lo cual serán eliminados de nuestros sistemas.</p>

                    <h2>Base Legal para el Tratamiento de Datos</h2>
                    <p>Procesamos su información personal sobre la base de su consentimiento explícito, otorgado al completar el formulario de contacto.</p>

                    <h2>Derechos del Usuario</h2>
                    <p>Usted tiene derecho a:</p>
                    <ul>
                        <li>Acceder a la información que hemos recopilado sobre usted.</li>
                        <li>Solicitar la corrección o eliminación de sus datos personales.</li>
                        <li>Limitar el uso que hacemos de su información.</li>
                    </ul>
                    <p>Para ejercer cualquiera de estos derechos, puede contactarnos a través del correo electrónico <a href="mailto:info@sereslatam.com">info@sereslatam.com</a>.</p>

                    <h2>Seguridad de la Información</h2>
                    <p>Implementamos medidas técnicas y organizativas adecuadas para proteger su información personal frente a accesos no autorizados, pérdidas o alteraciones.</p>

                    <h2>Modificaciones a la Política</h2>
                    <p>Esta Política de Privacidad puede ser modificada ocasionalmente. Cualquier cambio será comunicado a través de esta página. Recomendamos revisarla periódicamente para mantenerse informado.</p>

                    <h2>Ley Aplicable y Jurisdicción</h2>
                        <p>
                            Estos términos y condiciones se rigen por las leyes de la República de Guatemala. En caso de controversias, las partes se someten a la jurisdicción de los tribunales correspondientes en Guatemala.
                        </p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Privacidad;